import { useSelector } from "react-redux";
import CreateUserForm from "../components/Requests/CreateUserForm";

const CreateUser = () => {
    const currentAdmin = useSelector((state) => state.user.untouched);
    return <CreateUserForm item={false} currentAdmin={currentAdmin} />;
};
export default CreateUser;
